// @ts-strict-ignore
import React from 'react';

import { FourArticlesHighlightBlockData } from 'api/cms';
import { PublicPage } from 'api/website';
import { useContentSubsite } from 'cms/hooks';
import { Box } from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import { RichTextHeadline } from 'components/Text';
import { gutterWidth } from 'theme';
import { identity, isNotEmpty } from 'utils/functional';

import { FourArticlesHighlightBlockPageSection } from './FourArticlesHighlightBlockPageSection';

type Props = {
  content: PublicPage;
  data: FourArticlesHighlightBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function FourArticlesHighlightBlock({
  content,
  data,
  blockIndex,
  pageUpdated,
}: Props) {
  const subsite = useContentSubsite({ content });
  const ARTICLES = ['One', 'Two', 'Three', 'Four']
    .map((page) => data[`page${page}`])
    .filter(identity);

  const { headline, buttonText, buttonUrl } = data;

  const displayImages =
    ARTICLES.some((page) => page.image) ||
    isNotEmpty(subsite.placeholderImages);

  return (
    <Box
      data-qa-id="cms-four-article-highlight"
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      width="100%"
    >
      {headline && (
        <RichTextHeadline mb={[gutterWidth / 2, null, null, gutterWidth]}>
          {headline}
        </RichTextHeadline>
      )}

      <Box
        display="flex"
        flexWrap="wrap"
        flex="0 0 auto"
        width="100%"
        mx={[-gutterWidth / 4, null, null, -gutterWidth / 2]}
      >
        {ARTICLES.map((page, index) => (
          <FourArticlesHighlightBlockPageSection
            qaId={`four-article-highlight-section-${index}`}
            page={page}
            key={page.id}
            displayImages={displayImages}
            blockIndex={blockIndex}
            pageUpdated={pageUpdated}
            subsite={subsite}
          />
        ))}
      </Box>

      {buttonText && buttonUrl && (
        <Box mt={['32px', null, '52px']} width="100%">
          <PrimaryButtonLink href={buttonUrl}>{buttonText}</PrimaryButtonLink>
        </Box>
      )}
    </Box>
  );
}
